import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { PouchOperationActivityType } from '../enums/PouchOperationActivityType'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class PouchOperationFilterEntity {
  pouchId!: number
  user?: UserMiniEntity
  startDate?: string
  endDate?: string
  type?: PouchOperationActivityType
  hasRoundDifference?: boolean
  referenceCode?: string
  fromPouchDriver?: DriverEntity
  page?: number
  limit?: number
}
